import { APIContainer } from './contexts/api-container';
import { Route, Routes, useLocation } from 'react-router-dom';
import ChatPage from './pages/chat';
import ChatHistory from './pages/chat-history';
import {
	CssBaseline as JoyCssBaseline,
	CssVarsProvider as JoyCssVarsProvider,
	ThemeProvider as JoyThemeProvider,
} from '@mui/joy';
import { joyTheme } from './theme/index';
import AnimationWrapper from '@mono-farmart-web/ui-components/transitions/AnimationWrapper';

export { APIContainer } from './contexts/api-container';

function App() {
	const location = useLocation();

	return (
		<JoyCssVarsProvider theme={joyTheme}>
			<JoyThemeProvider theme={joyTheme}>
				<JoyCssBaseline />
				<AnimationWrapper>
					<Routes location={location}>
						<Route index element={<ChatPage />} />
						<Route path='c/:chatId' element={<ChatPage />} />
						<Route path='history' element={<ChatHistory />} />
						{/* <Route path="customisation" element={<CustomPrompts />} /> */}
						<Route path='*' element={<ChatPage />} />
					</Routes>
				</AnimationWrapper>
			</JoyThemeProvider>
		</JoyCssVarsProvider>
	);
}

export const FarmartAIPkg = () => {
	return (
		<APIContainer>
			<App />
		</APIContainer>
	);
};

export default App;
